import React, { useEffect, useState } from 'react';
function CustomLoader({ hasOverlay = false }) {
    return (
        <div className={`CustomLoader ${hasOverlay ? 'loader-overlay' : ''}`}>

            <div className="astm-spinner spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
}

export default CustomLoader;